import React, {useState, useEffect} from 'react'
import fuzzySearch from '../common/fuzzySearch'
import SelectSearch from "react-select-search";
import axios from "axios";
import ReactPaginate from 'react-paginate';

const SelectAddress = props => {
	
	const {baseUrl, publicUrl, allAddressesModalClose, setPopulatedPostCode, setPostcode, setPopulatedAddress, handleSetCountry, handleSetState, handleSetCity} = props

	const [allRecords, setAllRecords] = useState([])
	const [records, setRecords] = useState([])
	

	// for pagination
    const [postsPerPage, setPostsPerPage] = useState(7); // change this for change the limit records per page...
    const [offset, setOffset] = useState(1);
    const [posts, setAllPosts] = useState([]);
    const [pageCount, setPageCount] = useState(0)
    const [firstLoad, setFirstLoad] = useState(true)

	useEffect(() => {
   		axios.get(baseUrl + 'mm-api/get-addresses-with-all-data/')
            .then(r => {
                console.log('mm-api/get-addresses-with-all-data response:', r.data)

                setAllRecords(r.data.activeAddresses)
                handlePagination(r.data.activeAddresses)
            })
            .catch(e => {
                console.log(e)
            })
   	}, [offset])

   	const handlePagination = (items) => {
        console.log('in handlePagination')
        console.log('offset ' + offset)

        const data = items;

        if( firstLoad )
        {
            console.log('firstLoad')
            setFirstLoad(false)
            const slice = data.slice(offset - 1 , offset - 1 + postsPerPage)
        }
        else
        {
            console.log('load many time')
            let startIndex = (offset - 1) * postsPerPage; 
            let endIndex = Math.min(startIndex + postsPerPage , allRecords.length); 
            
            console.log('startIndex : ' + startIndex)
            console.log('endIndex : ' + endIndex)
            const slice = data.slice(startIndex , endIndex)
        }

        setRecords(slice)
        setPageCount(Math.ceil(data.length / postsPerPage))
    }

    const handlePageClick = (event) => {
       const selectedPage = event.selected;
       setOffset(selectedPage + 1)
    };

    const handleSelectAddressClick = (item) => {
    	console.log('in handleSelectAddressClick')
    	handleSetCountry(item.countryCode)

        setPopulatedPostCode('')
        setPopulatedAddress('')

    	setTimeout(() => {

    	    if( item.stateId !== null)
    		    handleSetState(item.stateId)
            else
                handleSetState(item.state)

    		setTimeout(() => {

                if( item.cityId !== null)
                    handleSetCity(item.cityId)
               else
                    handleSetCity(item.city)

                if( item.postCodeId !== null) {
                    setTimeout(() => {
                        setPostcode(item.postCodeId)
                        setPopulatedAddress(item.streetName)
                    }, 1500);
                }

    		}, 1500);

    	}, 1500);

        if( item.postCodeId === null) {
            setPopulatedPostCode(item.postCode)
            setPopulatedAddress(item.streetName)
        }

    	allAddressesModalClose()
    }

	return (
        <div className="modal-new-style tools-page" style={{width:1000}}>
            <div className="modal-content">
                <div className="modal-header">
                    <img src={publicUrl + 'img/mobile-moxie.png'} alt="" height="50"/>
                    <h3 className="modal-title" id="addurlslabel">
                        Select Address
                    </h3>
                    <button type="button" className="close" onClick={allAddressesModalClose}>
                        <i className="material-icons">clear</i>
                    </button>
                </div>
                <div className="modal-body address-selectall-otable">
				    <table className="table table-striped table-bordered data-table-addresses dataTable address" id="data_table_active_address">
				        <thead className="hidden-xs hidden-sm">
				            <tr>
				              <th className="no-sort w125">Address Nickname</th>
				              <th className="no-sort w100">Street</th>
				              <th className="w70 post-code">Post Code</th>
				              <th className="city w100">City</th>
				              <th className="state">State</th>
				              <th className="country hidden-sm">Country</th>
				            </tr>
				        </thead>
				    	<tbody>
				    		{records.map((item, i) => (
				    			<tr id={'address_' + (item.id)} 
				    				className="selectAddress" 
				    				data-countrycode={item.countryCode} 
				    				data-state={item.state} 
				    				data-city={item.city} 
				    				data-postcode={item.postCode} 
				    				data-streetname={item.streetName} 
				    				style={{cursor:'pointer'}}
				    				onClick={(e) => handleSelectAddressClick(item)}
				    			>
				    				<td className="text-truncate">
						                <b className="visible-xs visible-sm">Address Nickname</b>
						                <span className="addressNickname">{item.addressNick}</span>
						            </td>
						            <td>
						                <b className="visible-xs">Street</b>
						                <span className="streetName" data-toggle="tooltip" title={item.streetName}>{item.streetName}</span>
						            </td>
						            <td>
						                <b className="visible-xs visible-sm">Post Code</b>
						                <span className="postCode">{item.postCode}</span>
						            </td>
						            <td>
						                <b className="visible-xs visible-sm">City</b>
						                <span className="city">{item.cityName}</span>
						            </td>
						            <td>
						                <b className="visible-xs visible-sm">State</b>
						                <span className="state" data-toggle="tooltip" title={item.state }>{item.state}</span>
						            </td>
						            <td className="">
						                <b className="visible-xs visible-sm">Country</b>
						                <span className="country">{item.countryName}</span>
						            </td>
				    			</tr>
				    		))}
				    	</tbody>
				   	</table>
				   	<div className="row">
                        <div className="col-md-12 col-xs-12">
                            <ReactPaginate
                               previousLabel={"previous"}
                               nextLabel={"next"}
                               breakLabel={"..."}
                               breakClassName={"break-me"}
                               pageCount={pageCount}
                               onPageChange={handlePageClick}
                               containerClassName={"pagination"}
                               subContainerClassName={"pages pagination"}
                               activeClassName={"active"} />
                        </div>
                    </div>
				</div>
            </div>
        </div>
    )

}

export default SelectAddress